import { Component, Renderer2 } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { LoginService } from './services/login.service';
import { ThemeService } from './services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
    inputStyle = 'outlined';

    ripple: boolean;

    theme: string;

    constructor(
        private primengConfig: PrimeNG,
        private themeService: ThemeService,
        private loginService: LoginService,
        private renderer: Renderer2
    ) {
        this.themeService.theme.subscribe((t) => {
            this.renderer.removeClass(document.body, this.theme);
            this.theme = t;
            this.renderer.addClass(document.body, this.theme);
            console.log("theme change", t);
        })
    }

    async ngOnInit() {
        this.primengConfig.ripple.set(true);
        this.ripple = true;
    }
}
